import { formatDateToISO8601 } from "../../../features/dataFunctions/format/date";
import { getObjectTypeFromLayerName } from "../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/handleFeature/default";

// 
// objectTypes: string[] | string,
// filters: {
//    [objectType]: string
// }
// 
export function configureObjectTypesWithFiltersForTableUnderMap(
    menuItem: any,
    appliedFilters: any = {},
    tableUnderMapFiltersExpressions = {},
): { objectTypes: string[] | string, tableFilters: any } | undefined {
    if (!menuItem) return undefined;
    const { mapLayer } = menuItem ?? {};
    if (!mapLayer) return undefined;

    const layerIsGrouped = Array.isArray(mapLayer)

    const objectTypes: any = []
    const filters: any = {}
    const [layerVisibilityFilterName, layerVisibilityFilter]: any = Object.entries(appliedFilters).find(([, filter]: any) => filter.type === "layer") ?? [];
    const { appliedValues: layerVisibilityFilterAppliedValues, isIgnored: layerVisibilityFilterIsIgnored } = layerVisibilityFilter ?? {};

    if (layerIsGrouped) {
        mapLayer.forEach((layer: any) => {
            const { id, name, applicableFilters, showInTable } = layer ?? {}
            let dynamicFilter;
            if (tableUnderMapFiltersExpressions) {
                if (applicableFilters) {
                    dynamicFilter = Object.entries(tableUnderMapFiltersExpressions).filter(([fieldName,]: any) => applicableFilters.includes(fieldName)).map(([, expression]: any) => expression).join(' and ');
                } else {
                    dynamicFilter = Object.values(tableUnderMapFiltersExpressions).join(' and ')
                }
            }
            let layerIsShown = true;
            const valueAllowed = layerVisibilityFilterAppliedValues?.[id] || layerVisibilityFilterIsIgnored;
            layerIsShown = applicableFilters?.includes(layerVisibilityFilterName) === false || valueAllowed;
            if (layerIsShown) {
                const objectType = getObjectTypeFromLayerName(name)
                if (showInTable && objectType) {
                    objectTypes.push(objectType)
                    filters[objectType] = dynamicFilter
                }
            }
        })
    }

    if (objectTypes.length === 1) return { objectTypes: objectTypes[0], tableFilters: filters };
    if (objectTypes.length === 0) return undefined;

    return { objectTypes, tableFilters: filters };
}

// 
// tableUnderMapFiltersExpressions: {
//     [filterName]: string
// }
// 
export function configureTableUnderMapFiltersExpressionsFromAppliedFilters(appliedFilters: any) {
    const tableUnderMapFiltersExpressions: any = {}
    Object.entries(appliedFilters).map(([fieldName, appliedFilter]: any) => {
        const { type, format, includeNull, isIgnored, operation } = appliedFilter ?? {}
        let filterExpression = "";
        if (type === 'value') {
            // if (type === 'input') {
            // 
            // }
            if (format === 'list-checkbox' || format === 'tree-checkbox' || format === "list-radio") {
                const { appliedValues } = appliedFilter
                const allValues = Object.keys(appliedValues);
                const activeValues = allValues.filter(k => appliedValues[k]);   // выделены «true»
                if (operation === 'equals') {
                    if (isIgnored) {
                        filterExpression += `(${allValues.map(value => `${fieldName} eq ${value}`).join(' or ')})`;
                    } else if (activeValues.length) {
                        filterExpression += `(${activeValues.map(value => `${fieldName} eq ${value}`).join(' or ')}`;
                        if (includeNull) filterExpression += ` or ${fieldName} eq null`;
                        filterExpression += ')';
                    } else {
                        filterExpression += includeNull ? `(${fieldName} eq null)` : `(false)`;
                    }
                }
                if (operation === 'includes') {
                    const target = isIgnored ? allValues : activeValues;
                    if (!target.length && !isIgnored) {
                        filterExpression += includeNull ? `(${fieldName} eq null)` : `(false)`;
                    } else {
                        const likeChain = target
                            .map(v => `contains(${fieldName}, ',${v},')`)
                            .join(' or ');
                        filterExpression += `(${likeChain}`;
                        if (includeNull) filterExpression += ` or ${fieldName} eq null`;
                        filterExpression += ')';
                    }
                }
            }
            if (format === 'calendar') {
                const { minValue, maxValue, value } = appliedFilter ?? {};

                if (operation === 'between' && minValue && maxValue && !isIgnored) {
                    const from = formatDateToISO8601(minValue);
                    const to = formatDateToISO8601(maxValue);

                    filterExpression = `${fieldName} ge '${from}' and ${fieldName} le '${to}'`;
                }

                if (operation === 'from' && value && !isIgnored) {
                    const from = formatDateToISO8601(value);
                    filterExpression = `${fieldName} ge '${from}'`;
                }

                if (operation === 'to' && value && !isIgnored) {
                    const to = formatDateToISO8601(value)
                    filterExpression = `${fieldName} le '${to}'`;
                }
            }
        }
        if (filterExpression) tableUnderMapFiltersExpressions[fieldName] = filterExpression;
    })
    return tableUnderMapFiltersExpressions
}